module.exports = __webpack_public_path__ + "static/img/app1.3bd6ef7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/app1.png
// module id = +0HH
// module chunks = 1